/** Scroll the app shell content region (not the window) back to the top. */
export function scrollMainToTop(): void {
  const scrollEl = document.querySelector(".main__scroll");
  if (scrollEl instanceof HTMLElement) {
    scrollEl.scrollTop = 0;
    return;
  }
  window.scrollTo(0, 0);
}
